import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';
import LogbookSignatureModal from '../LogbookAppIntegration/LogbookSignatureModal';

class AircraftsEdit extends Component {

  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      logbook_external_id: '',
      registration: null,
      engine_1_id: null,
      engine_2_id: null,
      cost_center_crew: null,
      cost_center_manager: null,
      operation_type_id: null,
      serial_number: null,
      ptbr_code: null,
      ca: null,
      iam: null,
      weight: null,
      ground_consumption: null,
      flight_consumption: null,
      fuel_capacity: null,
      cost_centers: [],
      cost_centers_select: [],
      hums: 0,
      fdm: 0,
      external_load: 0,
      out_of_service: 0,
      schedule_only: 0,
      aircraft_models_list: [],
      aircraft_model_versions_list: [],
      engines_list: [],
      operation_types: [],
      cost_center_id: null,
      role_type: null,
      role_types_select: [
        {value: 'crew', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Tripulacao},
        {value: 'cvo', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.CVODVO},
        {value: 'master', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.MestreDeCarga},
        {value: 'mechanic', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Mecanico},
        {value: 'management', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Administrativo},
        {value: 'indirect', label: this.locale.Aeronaves.EditarAeronaves.opcoesTipoDeCargo.Indireto},
      ],
      aircraft_model_id: null,
      aircraft_model_version_id: null,
      logbook: 0,
      logbook_date_open: '',
      logbook_date_closed: '',
      initial_flight_hours: '',
      actual_flight_hours: '',
      initial_landings: '',
      actual_landings: '',
      email: '',
      password: '',
      showLogbookSignatureModal: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addCostCenter = this.addCostCenter.bind(this);
    this.deleteCostCenter = this.deleteCostCenter.bind(this);
    this.voeOmniUpdate = this.voeOmniUpdate.bind(this);
    this.logbookIntegration = this.logbookIntegration.bind(this);
    this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectAircraftModelChange(name, event) {
    var change = {};
    var self = this;
    change['aircraft_model_version_id'] = null;
    if(event == null) {
      change[name] = null;
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/aeronave/modelo/versoes/lista/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({aircraft_model_versions_list: responseJson.data});
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        });
      });
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    var value = event.target.checked === true ? 1 : 0;
    change[name] = value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  validateFlightHours(value, event) {
    const hourPattern = /^\d{1,6}:[0-5][0-9]$/;
    if (!hourPattern.test(value) && value !== '' && value !== null && value !== undefined) {
      this.setState({overlay: {message: 'Os campos de horas devem estar no formato HH:MM, com até 6 dígitos para as horas e minutos entre 00 e 59.', type: 'error', status: 'open'}});
      return false;
    }
    return true;
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/aeronave/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            logbook_external_id: responseJson.data.main.logbook_external_id,
            registration: responseJson.data.main.registration,
            engine_1_id: responseJson.data.main.engine_1_id,
            engine_2_id: responseJson.data.main.engine_2_id,
            cost_center_crew: responseJson.data.main.cost_center_crew,
            cost_center_manager: responseJson.data.main.cost_center_manager,
            aircraft_model_id: responseJson.data.main.aircraft_model_id,
            aircraft_model_version_id: responseJson.data.main.aircraft_model_version_id,
            operation_type_id: responseJson.data.main.operation_type_id,
            serial_number: responseJson.data.main.serial_number,
            ptbr_code: responseJson.data.main.ptbr_code,
            ca: responseJson.data.main.ca_str,
            iam: responseJson.data.main.iam_str,
            weight: responseJson.data.main.weight_str,
            ground_consumption: responseJson.data.main.ground_consumption,
            flight_consumption: responseJson.data.main.flight_consumption,
            fuel_capacity: responseJson.data.main.fuel_capacity,
            cost_centers: responseJson.data.cost_centers,
            hums: responseJson.data.main.hums,
            fdm: responseJson.data.main.fdm,
            external_load: responseJson.data.main.external_load,
            out_of_service: responseJson.data.main.out_of_service,
            schedule_only: responseJson.data.main.schedule_only,
            logbook: responseJson.data.main.logbook,
            logbook_date_open: responseJson.data.main.logbook_date_open_str,
            logbook_date_closed: responseJson.data.main.logbook_date_closed_str,
            initial_flight_hours: responseJson.data.main.initial_flight_hours_str,
            actual_flight_hours: responseJson.data.main.actual_flight_hours_str,
            initial_landings: responseJson.data.main.initial_landings,
            actual_landings: responseJson.data.main.actual_landings,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        var url = config.get('api') + '/aeronave/modelo/versoes/lista/'+self.state.aircraft_model_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_model_versions_list: responseJson.data});
        }
      }).then(() => {
        var url = config.get('api') + '/aeronave/modelo/motores/geral/lista/'+self.state.aircraft_model_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({engines_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/tipo/operacoes/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ operation_types: responseJson.data });
          }
        }).then(() => {
          var url = config.get('api') + '/centros-de-custo/lista';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.setState({ cost_centers_select: responseJson.data });
            }
            }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); }); }); }); });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      registration: this.state.registration,
      engine_1_id: this.state.engine_1_id,
      engine_2_id: this.state.engine_2_id,
      cost_center_crew: this.state.cost_center_crew,
      cost_center_manager: this.state.cost_center_manager,
      aircraft_model_id: this.state.aircraft_model_id,
      aircraft_model_version_id: this.state.aircraft_model_version_id,
      operation_type_id: this.state.operation_type_id,
      serial_number: this.state.serial_number,
      ptbr_code: this.state.ptbr_code,
      ca: this.state.ca,
      iam: this.state.iam,
      weight: this.state.weight,
      hums: this.state.hums,
      fdm: this.state.fdm,
      external_load: this.state.external_load,
      out_of_service: this.state.out_of_service,
      schedule_only: this.state.schedule_only,
      logbook: this.state.logbook,
      logbook_date_open: this.state.logbook_date_open,
      logbook_date_closed: this.state.logbook_date_closed,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
      initial_flight_hours: this.state.initial_flight_hours,
      initial_landings: this.state.initial_landings,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  addCostCenter(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_id: this.state.id,
      cost_center_id: this.state.cost_center_id,
      role_type: this.state.role_type,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/centro/custo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if(responseJson.status === 'success') {
          self.setState({ cost_centers: responseJson.data });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch salvando a edição
  deleteCostCenter(id) {
    if(window.confirm(this.locale.Aeronaves.EditarAeronaves.deletarCentroDeCusto)) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/centro/custo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'success') {
            self.setState({ cost_centers: responseJson.data });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Atualização de dados com o VoeOmni
  voeOmniUpdate(event) {
    event.preventDefault();
    if(window.confirm(this.locale.Aeronaves.EditarAeronaves.atualizarVoeOmni)) {
      this.handleAlert('', '', 'open');
      var id = this.state.id;
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/voeomni/' + id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if(responseJson.status === 'success') {
            self.setState({
              weight: responseJson.data.weight_str,
              ground_consumption: responseJson.data.ground_consumption,
              flight_consumption: responseJson.data.flight_consumption,
              fuel_capacity: responseJson.data.fuel_capacity,
            });
          }
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Integração com o Logbook App
  logbookIntegration(event) {
    event.preventDefault();
    this.setState({ showLogbookSignatureModal: true });
  }

  handleLogbookSignatureSubmit(credentials) {
    this.setState({
      email: credentials.email,
      password: credentials.password,
      showLogbookSignatureModal: false
    }, () => {
      this.logbookIntegrationSubmit();
    });
  }

  logbookIntegrationSubmit() {
    const datasave = {
      id: this.state.id,
      email: this.state.email,
      password: this.state.password
    };
    const header = this.refs.request_api.header('application/json');
    const self = this;
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/integrar/logbook/aeronave', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: JSON.stringify(datasave)
      })
        .then((response) => response.json())
        .catch((error) => { console.error(error); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        })
        .catch((error) => { console.error(error); });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Aeronaves.EditarAeronaves.titulo}</h3>
      <div className="grid-buttons pull-right">
        <Link to="/aeronaves" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Modelo}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.SelecioneModeloAeronave}
                onChange={this.handleSelectAircraftModelChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
                disabled
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Matricula}:</label>
              <input type="text" name="registration" className="form-control" placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.registration} onChange={this.handleChange.bind(this, 'registration')} disabled />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="operation_type_id"
                value={this.state.operation_type_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.SelecionarTipoOperacao}
                onChange={this.handleSelectChange.bind(this, 'operation_type_id')}
                options={this.state.operation_types}
                disabled
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.NumeroSerie}:</label>
              <input type="text" name="serial_number" className="form-control" placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.RegistroAeronave} value={this.state.serial_number} onChange={this.handleChange.bind(this, 'serial_number')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CentroCustoTripulacao}:</label>
              <input type="text" className="form-control" name="cost_center_crew" value={this.state.cost_center_crew} onChange={this.handleChange.bind(this, 'cost_center_crew')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CentroCUstoCoordenacao}:</label>
              <input type="text" className="form-control" name="cost_center_manager" value={this.state.cost_center_manager} onChange={this.handleChange.bind(this, 'cost_center_manager')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CA}:</label>
              <InputMask value={this.state.ca}  maskChar={null} name="ca" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'ca')} placeholder={this.locale.general.diaMesAno} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.IAM}:</label>
              <InputMask value={this.state.iam}  maskChar={null} name="iam" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'iam')} placeholder={this.locale.general.diaMesAno} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Peso}:</label>
              <input value={this.state.weight} name="weight" className="form-control" onChange={this.handleChange.bind(this, 'weight')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.AdicionarAeronaves.formulario.OutOfService}</label>
              <br/>
              <Toggle checked={this.state.out_of_service} aria-label='No label tag' name="out_of_service" onChange={this.handleToggleChange.bind(this, 'out_of_service')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Utilizada somente em escala:</label>
              <br/>
              <Toggle checked={this.state.schedule_only} aria-label='No label tag' name="schedule_only" onChange={this.handleToggleChange.bind(this, 'schedule_only')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CodigoPTBR}:</label>
              <input value={this.state.ptbr_code} name="ptbr_code" className="form-control" onChange={this.handleChange.bind(this, 'ptbr_code')} placeholder="" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Hums}</label>
              <br/>
              <Toggle checked={this.state.hums} aria-label='No label tag' name="hums" onChange={this.handleToggleChange.bind(this, 'hums')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Fdm}</label>
              <br/>
              <Toggle checked={this.state.fdm} aria-label='No label tag' name="fdm" onChange={this.handleToggleChange.bind(this, 'fdm')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CargaExterna}</label>
              <br/>
              <Toggle checked={this.state.external_load} aria-label='No label tag' name="external_load" onChange={this.handleToggleChange.bind(this, 'external_load')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Versao}:</label>
              <Select
                className="form-field-name"
                name="aircraft_model_version_id"
                value={this.state.aircraft_model_version_id}
                searchable={true}
                placeholder={this.locale.Aeronaves.EditarAeronaves.formulario.placeholder.SelecionarVersao}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_version_id')}
                options={this.state.aircraft_model_versions_list}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.Logbook}</label>
              <br/>
              <Toggle checked={this.state.logbook} aria-label='No label tag' name="logbook" onChange={this.handleToggleChange.bind(this, 'logbook')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>Logbook App:</label>
              <button onClick={this.logbookIntegration} className="btn btn-primary btn-block">
                <i className="fa fa-link"></i> {this.locale.Aeronaves.EditarAeronaves.formulario.botaoIntegrarLogbook}
              </button>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.DataAberturaLogbook}:</label>
              <br/>
              <InputMask value={this.state.logbook_date_open}  maskChar={null} name="logbook_date_open" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'logbook_date_open')} placeholder={this.locale.general.diaMesAno} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Aeronaves.EditarAeronaves.formulario.DataEncerramentoLogbook}:</label>
              <InputMask value={this.state.logbook_date_closed}  maskChar={null} name="logbook_date_closed" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'logbook_date_closed')} placeholder={this.locale.general.diaMesAno} />
            </div>
          </div>
        </div>
        {
          this.state.logbook === 1 &&
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Aeronaves.EditarAeronaves.formulario.HorasIniciais}:</label>
                  <input type="text" name="initial_flight_hours" className="form-control" value={this.state.initial_flight_hours} onChange={this.handleChange.bind(this, 'initial_flight_hours')} onBlur={this.validateFlightHours.bind(this, this.state.initial_flight_hours)} placeholder="00000:00" required />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Aeronaves.EditarAeronaves.formulario.HorasAtuais}:</label>
                  <input type="text" name="actual_flight_hours" className="form-control" value={this.state.actual_flight_hours} onChange={this.handleChange.bind(this, 'actual_flight_hours')} onBlur={this.validateFlightHours.bind(this, this.state.actual_flight_hours)} placeholder="00000:00" disabled />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Aeronaves.EditarAeronaves.formulario.PousosIniciais}:</label>
                  <input type="number" value={this.state.initial_landings} name="initial_landings" className="form-control" onChange={this.handleChange.bind(this, 'initial_landings')} placeholder="0" required />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>{this.locale.Aeronaves.EditarAeronaves.formulario.PousosAtuais}:</label>
                  <input type="number" value={this.state.actual_landings} name="actual_landings" className="form-control" onChange={this.handleChange.bind(this, 'actual_landings')} placeholder="0" disabled />
                </div>
              </div>
            </div>
        }
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Engine #1:</label>
              <Select className="form-field-name" name="engine_1_id" value={this.state.engine_1_id} searchable={true} placeholder='Select' onChange={this.handleSelectChange.bind(this, 'engine_1_id')} options={this.state.engines_list} required={this.state.logbook === 1 ? true : false} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Engine #2:</label>
              <Select className="form-field-name" name="engine_2_id" value={this.state.engine_2_id} searchable={true} placeholder='Select' onChange={this.handleSelectChange.bind(this, 'engine_2_id')} options={this.state.engines_list} required={this.state.logbook === 1 ? true : false} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Aeronaves.EditarAeronaves.formulario.botaoSalvarEdicao}</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <LogbookSignatureModal
    show={this.state.showLogbookSignatureModal}
    onHide={() => this.setState({ showLogbookSignatureModal: false })}
    onSubmit={this.handleLogbookSignatureSubmit}
    title="Você tem certeza de que deseja integrar os dados desta aeronave com o Logbook App?"
    subtitle="Ao confirmar a integração será ativada para esta aeronave e será exigida a integração para todos os dados de diários de bordo."
  />
</div>
    );
  }
}

export default AircraftsEdit;



// WEBPACK FOOTER //
// ./src/Components/Aircrafts/AircraftsEdit.js